import _ from 'lodash';
import * as types from './types';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';

const INITIAL_STATE = {
  submitting: false,
  submitted: false,
  submitError: null,
  fetchingItemStorageLocationError: false,
  itemStorageLocationData: null,
  fetchingItemStorageLocation: false,

  gridStorageDropDownData: [],
  gridStorageLocationDataLoading: false,
  gridStorageLocationDataError: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.ITEM_STORAGE_LOCATION_DATA:
      const storageLocationData = _.cloneDeep(action.payload);
      const siteStorageLocListData = _.sortBy(
        storageLocationData.SiteStorageLocList,
        item => {
          return !item.StoreId;
        }
      );
      storageLocationData.SiteStorageLocList = siteStorageLocListData;
      return {
        ...state,
        itemStorageLocationData: storageLocationData,
      };
    case types.ITEM_STORAGE_LOCATION_LOADING_ERROR:
      const fetchingError = action.payload.response;
      if (
        _.has(fetchingError, 'data.Errors') &&
        fetchingError.data.Errors.length
      ) {
        return {
          ...state,
          fetchingItemStorageLocationError: fetchingError.data.Errors,
        };
      }
      return {
        ...state,
        fetchingItemStorageLocationError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while fetching Storage Locations. Please try again.',
        },
      };
    case types.ITEM_STORAGE_LOCATION_LOADING:
      return {
        ...state,
        fetchingItemStorageLocation: action.payload,
      };

    case types.ITEM_STORAGE_LOCATION_SUBMITTING:
      return {
        ...state,
        submitting: action.payload,
      };
    case types.ITEM_STORAGE_LOCATION_SUBMIT:
      return {
        ...state,
        submitted: true,
      };
    case types.ITEM_STORAGE_LOCATION_SUBMIT_ERROR:
      const submitResponseError = action.payload.response;
      if (
        _.has(submitResponseError, 'data.Errors') &&
        submitResponseError.data.Errors.length
      ) {
        return {
          ...state,
          submitError: submitResponseError.data.Errors,
        };
      }
      return {
        ...state,
        submitError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while fetching Storage Locations. Please try again.',
        },
      };
    case types.CLEAR_ITEM_ERROR_SUCCESS:
      return {
        ...state,
        submitted: false,
        submitError: null,
      };

    case types.ITEM_STORAGE_LOCATION_DROPDOWN_DATA: {
      return {
        ...state,
        gridStorageDropDownData: action.payload,
      };
    }
    case types.ITEM_STORAGE_LOCATION_DROPDOWN_LOADING_ERROR:
      const gridStorageLocationDataError = action.payload.response;
      if (
        _.has(gridStorageLocationDataError, 'data.Errors') &&
        gridStorageLocationDataError.data.Errors.length
      ) {
        return {
          ...state,
          gridStorageLocationDataError:
            gridStorageLocationDataError.data.Errors,
        };
      }
      return {
        ...state,
        gridStorageLocationDataError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while fetching Grid Storage Locations. Please try again.',
        },
      };
    case types.ITEM_STORAGE_LOCATION_DROPDOWN_LOADING:
      return {
        ...state,
        gridStorageLocationDataLoading: action.payload,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/inventory/itemmaintenance/state/itemStorageLocation/reducer.js